var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.48148 20V10.6154H0V7.23652H2.48148V4.3505C2.48148 2.08264 3.9473 0 7.32486 0C8.69238 0 9.7036 0.1311 9.7036 0.1311L9.62392 3.28642C9.62392 3.28642 8.59264 3.27638 7.46726 3.27638C6.24926 3.27638 6.05412 3.83768 6.05412 4.7693V7.23652H9.72074L9.5612 10.6154H6.05412V20H2.48148Z","fill":"#F9FAFA"}));
}

Facebook.defaultProps = {"width":"10","height":"20","viewBox":"0 0 10 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
